import type {Layout, Pointer, PS} from '@wix/document-services-types'
import _ from 'lodash'
import component from '../../component/component'
import componentData from '../../component/componentData'

function isVerticalResize(newLayout: Layout, currLayout: Layout): boolean | undefined {
    if (newLayout && !_.isUndefined(newLayout.height) && currLayout) {
        return newLayout.height !== currLayout.height
    }
}

export default function (ps: PS, compPointer: Pointer, newLayout: Layout) {
    if (isVerticalResize(newLayout, component.layout.get(ps, compPointer))) {
        if (component.properties.get(ps, compPointer)) {
            componentData.splitMobileComponentProperties(ps, compPointer)
        }
        component.properties.update(ps, compPointer, {
            minHeight: newLayout.height
        })
    }
}
